import { ImageField } from "./ImageField";
import { ListField } from "./ListField";

const SimpleControl = ({ field, value, onChange, testId }) => {
  if (field.type === "textarea")
    return <textarea rows={3} value={value || ""} onChange={(e) => onChange(e.target.value)} className="admin-input" data-testid={testId} />;
  if (field.type === "lines")
    return <textarea rows={4} value={(value || []).join("\n")} onChange={(e) => onChange(e.target.value.split("\n"))} className="admin-input" data-testid={testId} />;
  if (field.type === "select")
    return (
      <select value={value || field.options[0].value} onChange={(e) => onChange(e.target.value)} className="admin-input" data-testid={testId}>
        {field.options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    );
  if (field.type === "image") return <ImageField value={value} onChange={onChange} testId={testId} />;
  return <input value={value || ""} onChange={(e) => onChange(e.target.value)} className="admin-input" data-testid={testId} />;
};

function renderField({ key, field, value, onChange, testId }) {
  const control =
    field.type === "list" ? (
      <ListField field={field} value={value} onChange={onChange} testId={testId} renderField={renderField} />
    ) : (
      <SimpleControl field={field} value={value} onChange={onChange} testId={testId} />
    );
  return (
    <div key={key} className="block">
      <span className="mb-1.5 block text-xs font-medium text-slate-300">{field.label}</span>
      {control}
      {field.hint && <span className="mt-1 block font-mono text-[11px] text-slate-500">{field.hint}</span>}
    </div>
  );
}

export const FieldInput = (props) => renderField(props);

export default FieldInput;
